module.exports = __webpack_public_path__ + "img/active_icon04.0cfa9c11.png";